

import React from 'react';
import { PageTitle, Card } from '../components/common';
import { mockProjectFeedback } from '../mockData';
import { ProjectFeedback } from '../types';

// Star Icon Component
const StarIcon: React.FC<{ filled: boolean }> = ({ filled }) => (
    <svg className={`w-5 h-5 ${filled ? 'text-yellow-400' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </svg>
);

// Star Rating Component
const StarRating: React.FC<{ rating: number }> = ({ rating }) => (
    <div className="flex">
        {[...Array(5)].map((_, i) => (
            <StarIcon key={i} filled={i < rating} />
        ))}
    </div>
);

// Feedback Card Component
const FeedbackCard: React.FC<{ feedback: ProjectFeedback }> = ({ feedback }) => (
    <Card className="p-6">
        <div className="flex justify-between items-start">
            <div>
                <h3 className="text-xl font-bold text-gray-900">{feedback.projectTitle}</h3>
                <p className="text-sm text-gray-500 mt-1">Reviewed on {feedback.reviewDate}</p>
            </div>
            <div className="flex items-center gap-3 text-right flex-shrink-0 ml-4">
                <img src={feedback.reviewer.avatar} alt={feedback.reviewer.name} className="w-12 h-12 rounded-full object-cover" />
                <div>
                    <p className="font-semibold text-gray-800">{feedback.reviewer.name}</p>
                    <p className="text-sm text-gray-500">{feedback.reviewer.role}</p>
                </div>
            </div>
        </div>

        <div className="my-4">
            <StarRating rating={feedback.rating} />
        </div>

        <p className="text-gray-700 leading-relaxed">
            {feedback.comment}
        </p>
    </Card>
);

// Main Page Component
const ReviewsPage: React.FC = () => {
    return (
        <div>
            <PageTitle title="Project Feedback" subtitle="Here's what your manager thinks about your work." />
            
            <div className="space-y-6">
                {mockProjectFeedback.map(feedback => (
                    <FeedbackCard key={feedback.id} feedback={feedback} />
                ))}
            </div>
        </div>
    );
};

export default ReviewsPage;